
<component
  v-if="getComponentByType(contentElement.content_type)"
  :is="getComponentByType(contentElement.content_type)"
  :content-element="contentElement"
  :is-in-detail-view-edit-mode="isInDetailViewEditMode"
  :entry="entry"
  :list-view="listView"
></component>
